// index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './context/AppContext';
import { TranslationProvider } from './context/TranslationContext';
import { FeatureFlagsProvider } from './context/FeatureFlagsContext';
import { NotificationsProvider } from './context/NotificationsContext';


// Create root and render app
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <TranslationProvider>
     <AuthProvider>
        <FeatureFlagsProvider>
          <NotificationsProvider>
           <AppProvider>
              <App />
           </AppProvider>
          </NotificationsProvider>
        </FeatureFlagsProvider>
     </AuthProvider>
    </TranslationProvider>
  </React.StrictMode>
);

reportWebVitals();
